// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import FupPersonListPagingResultModel from '../../model/fup-person-list-paging-result-model';
import FupPersonListPagingResultDTO from '../dto/fup-person-list-paging-result-dto';
import dtoSchema from '../schemas/fup-person-list-paging-result-schema';
import FupPersonListModel from '../../model/fup-person-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class FupPersonListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<FupPersonListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => FupPersonListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: FupPersonListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<FupPersonListPagingResultDTO>): FupPersonListPagingResultModel;
  static toModel(dto: DeepPartial<FupPersonListPagingResultDTO> | undefined | null): FupPersonListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<FupPersonListPagingResultDTO> | undefined | null): FupPersonListPagingResultModel | undefined {
    return dto ? new FupPersonListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<FupPersonListPagingResultModel> | FupPersonListPagingResultModel): FupPersonListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as FupPersonListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for FupPersonListPagingResultModel, can not map to FupPersonListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
